// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__-GjUy","Header":"Modal_Header__20UyC","Content":"Modal_Content__NKG2u"};